module.exports = __webpack_public_path__ + "static/img/fi_menu.e384b841.svg";